import { useIntl } from "react-intl";

type Props = {
    className?: string;
    content: string;
};

export const OwP = (props: Props) => {
    const intl = useIntl();
    const content = intl.formatMessage({ id: props.content });

    return <p className={props.className}>{content}</p>;
};
